import React from 'react'
import { useGetComponentBlueprintByCode } from '../../../../api/denali'
import DailyGreetingRedtailStandard from './DailyGreetingRedtailStandard'
import DailyGreetingRedtailWithBlueprintMeetings from './DailyGreetingRedtailWithBlueprintMeetings'
import { dailyGreetingRedtailOuterPropTypes } from './dailyGreetingPropTypes'

function DailyGreetingRedtail ({
  userName,
  meetingsLinkTo: _meetingsLinkTo,
  tasksLinkTo: _tasksLinkTo,
  overdueStartDate,
  tasksLinkMode: _tasksLinkMode,
  blueprintCode,
  meetingsPresentationKey,
  tasksPresentationKey
}) {
  const fetchBlueprint = Boolean(
    blueprintCode && (meetingsPresentationKey || tasksPresentationKey)
  )

  const { data: blueprint, isLoading: isLoadingBlueprint } = useGetComponentBlueprintByCode(
    blueprintCode,
    { enabled: fetchBlueprint, includes: { definition: true } }
  )

  const presentations = blueprint?.definition?.data?.presentations
  const meetingsSlot = meetingsPresentationKey
    ? presentations?.[meetingsPresentationKey]
    : undefined
  const useMeetingsListBranch = Boolean(
    blueprintCode &&
    meetingsPresentationKey &&
    (isLoadingBlueprint || meetingsSlot)
  )

  if (useMeetingsListBranch) {
    return (
      <DailyGreetingRedtailWithBlueprintMeetings
        userName={userName}
        meetingsLinkTo={_meetingsLinkTo}
        tasksLinkTo={_tasksLinkTo}
        overdueStartDate={overdueStartDate}
        tasksLinkMode={_tasksLinkMode}
        blueprintCode={blueprintCode}
        meetingsPresentationKey={meetingsPresentationKey}
        tasksPresentationKey={tasksPresentationKey}
        blueprint={blueprint}
        isLoadingBlueprint={isLoadingBlueprint}
        meetingsSlot={meetingsSlot}
      />
    )
  }

  return (
    <DailyGreetingRedtailStandard
      userName={userName}
      meetingsLinkTo={_meetingsLinkTo}
      tasksLinkTo={_tasksLinkTo}
      overdueStartDate={overdueStartDate}
      tasksLinkMode={_tasksLinkMode}
      blueprintCode={blueprintCode}
      tasksPresentationKey={tasksPresentationKey}
      blueprint={blueprint}
      isLoadingBlueprint={isLoadingBlueprint}
    />
  )
}

DailyGreetingRedtail.propTypes = dailyGreetingRedtailOuterPropTypes

export default DailyGreetingRedtail
